import React from "react";

export interface Props {
    entity: {
        id: string;
        value: string;
        type: string;
    },
    imgWidth?: number
}

export const AdminConfigValuePreview: React.FC<Props> = (props) => {
    return (
        <>
            {
                (props.entity.value?.length ?? 0) > 0 && <>
                    {
                        props.entity.type === 'image' &&
                        <a href={props.entity.value} className={"mb-4 d-block"} target="_blank">
                            <img
                                src={props.entity.value}
                                alt={"config"}
                                style={{maxWidth: (props?.imgWidth) ? props?.imgWidth + 'px' : '400px', border: '1px solid #000'}}
                                className={"mb-4 d-block"}
                            />
                        </a>
                    }
                    {
                        props.entity.type === 'file' &&
                        <a href={props.entity.value} className={"mb-4 d-block"} target="_blank">{props.entity.value}</a>
                    }
                    {
                        ['file', 'image'].includes(props.entity.type) === false &&
                        <span>{props.entity.value}</span>
                    }
                </>
            }
        </>
    );
}
